import * as React from 'react';

function CigaretteSmokingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.318 2.772a.75.75 0 0 1 .91.546c.174.7.334 1.586.13 2.528-.21.969-.782 1.91-1.908 2.754-.732.55-1.288 1.35-1.66 2.19-.376.843-.54 1.667-.54 2.21a.75.75 0 0 1-1.5 0c0-.79.224-1.82.668-2.82C4.864 9.176 5.56 8.143 6.55 7.4c.874-.656 1.218-1.298 1.342-1.871.13-.6.039-1.213-.12-1.847a.75.75 0 0 1 .546-.91m3.3 0a.75.75 0 0 1 .91.546c.382 1.53.233 4.048-2.078 5.782-1.44 1.08-1.7 2.652-1.7 3.9a.75.75 0 0 1-1.5 0c0-1.419.293-3.595 2.3-5.1 1.688-1.266 1.806-3.082 1.522-4.218a.75.75 0 0 1 .546-.91M2.75 18.5v-4h1.5v4zm13-2.5h3.75v1h-3.75zm-1.5-1.5h5.25A1.5 1.5 0 0 1 21 16v1a1.5 1.5 0 0 1-1.5 1.5h-14v-4zm0 2.5H7v-1h7.25z"
  }));
}

export { CigaretteSmokingIcon };
